import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IContentContext } from '../../common/interfaces/ContentContext.interface';

interface ContentContextState {
  isModalOpen: boolean;
  isModalOpenedForAdd: boolean;
  selectedContentContext: IContentContext | null;
  validationErrors: { [field: string]: string[] };
}

const initialState: ContentContextState = {
  isModalOpen: false,
  isModalOpenedForAdd: false,
  selectedContentContext: null,
  validationErrors: {},
};

const contentContextSlice = createSlice({
  name: 'contentContext',
  initialState,
  reducers: {
    setSelectedContentContext(
      state,
      action: PayloadAction<IContentContext | null>
    ) {
      state.selectedContentContext = action.payload;
    },
    clearSelectedContentContext(state) {
      state.selectedContentContext = null;
    },
    openContentContextModal(
      state,
      action: PayloadAction<{ isModalOpenedForAdd?: boolean } | undefined>
    ) {
      state.isModalOpen = true;
      state.isModalOpenedForAdd = action?.payload?.isModalOpenedForAdd ?? false;
    },
    closeContentContextModal(state) {
      state.isModalOpen = false;
      state.isModalOpenedForAdd = false;
    },
    setValidationErrors(
      state,
      action: PayloadAction<{ field: string; errors: string[] }>
    ) {
      state.validationErrors[action.payload.field] = action.payload.errors;
    },
    clearValidationErrors(state, action: PayloadAction<string>) {
      delete state.validationErrors[action.payload];
    },
    clearAllValidationErrors(state) {
      state.validationErrors = {};
    },
  },
});

export const {
  setSelectedContentContext,
  clearSelectedContentContext,
  openContentContextModal,
  closeContentContextModal,
  setValidationErrors,
  clearValidationErrors,
  clearAllValidationErrors,
} = contentContextSlice.actions;
export default contentContextSlice.reducer;
